<script setup>
import { fmt, formatUtc8DateTime, providerLabel } from "@/shared/utils/format";

defineProps({
  myUsage: { type: Object, default: null },
});
</script>

<template>
  <div class="card">
    <div class="card-head">
      <h2>我的上传状态</h2>
      <span v-if="myUsage" class="status-pill" :class="{ warn: myUsage.anomalyFlags.length }">
        {{ myUsage.anomalyFlags.length ? myUsage.anomalyFlags.join(", ") : "正常" }}
      </span>
    </div>
    <div v-if="myUsage" class="card-body">
      <div class="stat-label">今日 total tokens</div>
      <div class="big-number">{{ fmt.format(myUsage.totalTokens) }}</div>
      <div v-if="myUsage.providerBreakdown?.length" class="breakdown-grid">
        <div v-for="item in myUsage.providerBreakdown" :key="item.provider" class="breakdown-cell">
          <small>{{ providerLabel(item.provider) }}</small>
          <strong>{{ fmt.format(item.totalTokens) }}</strong>
        </div>
      </div>
      <dl class="detail-grid">
        <dt>input</dt>
        <dd>{{ fmt.format(myUsage.inputTokens) }}</dd>
        <dt>output</dt>
        <dd>{{ fmt.format(myUsage.outputTokens) }}</dd>
        <dt>cache read</dt>
        <dd>{{ fmt.format(myUsage.cacheReadTokens) }}</dd>
        <dt>cache create</dt>
        <dd>{{ fmt.format(myUsage.cacheCreationTokens) }}</dd>
        <dt>上传时间</dt>
        <dd>{{ formatUtc8DateTime(myUsage.uploadedAt) }}</dd>
      </dl>
    </div>
    <div v-else class="card-body">
      <p class="card-note">今天还没有上传 CodexBar 日汇总。</p>
    </div>
  </div>
</template>
